(function() {
  if (window.__cdInsuranceBound) return;
  window.__cdInsuranceBound = true;

  var cdInsuranceConfig = window.CD_INSURANCE || {};
  var insurancePriceCents = Number(cdInsuranceConfig.insurancePriceCents || 0);
  var moneyFormat = cdInsuranceConfig.moneyFormat || '${{amount}}';

  // const interval = setInterval(() => {
  //   const toggle = document.querySelector('.cd-insurance__toggle');

  //   if (toggle) {
  //     let isInsuranceAdded = cdInsuranceConfig.productInCart === true || cdInsuranceConfig.productInCart === 'true';

  //     if (!isInsuranceAdded) {
  //       toggle.click();
  //     }

  //     clearInterval(interval);
  //   }
  // }, 1500);

  function getDisplayedSubtotal() {
    let el = document.querySelectorAll('.cart-drawer__totals__row__money');
    el = el[1] ? el[1] : el[0];
    if (!el) return null;
    return el;
  }

  function parseCentsFromText(text) {
    var raw = text.replace(/[^0-9.,]/g, '').trim();

    var lastComma = raw.lastIndexOf(',');
    var lastPeriod = raw.lastIndexOf('.');

    if (lastComma > lastPeriod) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else if (lastPeriod > lastComma) {
      raw = raw.replace(/,/g, '');
    }

    return Math.round(parseFloat(raw) * 100);
  }

  function updateSubtotalDOM(addOrRemove) {
    var el = getDisplayedSubtotal();
    if (!el) return;

    var currentCents = parseCentsFromText(el.textContent);
    var newCents = addOrRemove === 'add'
      ? currentCents + insurancePriceCents
      : currentCents - insurancePriceCents;

    el.textContent = formatMoney(newCents);
  }

  function syncA11y(checkbox) {
    checkbox.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartDrawerSubtotal(cart) {
    var totalsWrap = document.querySelector('.cart-drawer__totals');
    if (!totalsWrap) return;

    var moneyNodes = totalsWrap.querySelectorAll('.cart-drawer__totals__row__money');
    if (!moneyNodes.length) return;

    var subtotalNode = moneyNodes[moneyNodes.length - 1];
    subtotalNode.textContent = formatMoney(cart.items_subtotal_price);
  }

  async function getCart() {
    var response = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) throw new Error('Failed to load cart.');
    return await response.json();
  }

  async function addInsurance(container) {
    var variantId = Number(container.dataset.variantId);
    var quantity = Number(container.dataset.quantity) || 1;

    if (!variantId || Number.isNaN(variantId)) {
      throw new Error('Missing valid variant ID.');
    }

    var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity
          }
        ]
      })
    });

    if (!response.ok) {
      var errorData = await response.json().catch(function() { return {}; });
      throw new Error(errorData.description || 'Failed to add insurance.');
    }

    // return await response.json();
  }

async function removeInsurance(container) {
  var variantId = Number(container.dataset.variantId);

  if (!variantId || Number.isNaN(variantId)) {
    throw new Error('Missing valid variant ID.');
  }

  console.log('Variant id is ', variantId);

  var response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: `${variantId}`,
      quantity: 0,
      sections: 'cart-drawer,cart-icon-bubble',       // 👈 added
      sections_url: window.location.pathname           // 👈 added
    })
  });

  const data = await response.json().catch(function() { return {}; });

  if (!response.ok) {
    throw new Error(data.description || 'Failed to remove insurance.');
  }

  // Update cart drawer
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    cartDrawer.renderContents(data);
  }

  // Update cart icon bubble
  const cartIconBubbleHTML = data.sections?.['cart-icon-bubble'];
  if (cartIconBubbleHTML) {
    document.querySelectorAll('[id^="cart-icon-bubble"]').forEach(el => {
      el.innerHTML = new DOMParser()
        .parseFromString(cartIconBubbleHTML, 'text/html')
        .querySelector('[id^="cart-icon-bubble"]')?.innerHTML ?? '';
    });
  }

  console.log('item is removed');
  return data;
}

  document.addEventListener('change', async function(event) {
    var checkbox = event.target.closest('.cd-insurance [data-insurance-toggle]');
    if (!checkbox) return;

    var container = checkbox.closest('.cd-insurance');
    if (!container) return;
    if (container.dataset.loading === 'true') return;

    container.dataset.loading = 'true';
    container.classList.add('is-loading');
    syncA11y(checkbox);

    try {
      if (checkbox.checked) {
        updateSubtotalDOM('add');
        await addInsurance(container);
      } else {
        updateSubtotalDOM('remove');
        await removeInsurance(container);
      }

      syncA11y(checkbox);
    } catch (error) {
      checkbox.checked = !checkbox.checked;
      updateSubtotalDOM(checkbox.checked ? 'add' : 'remove');
      syncA11y(checkbox);
      console.error(error);
    } finally {
      container.dataset.loading = 'false';
      container.classList.remove('is-loading');
    }
  });

  document.querySelectorAll('.cd-insurance [data-insurance-toggle]').forEach(function(checkbox) {
    syncA11y(checkbox);
  });
})();

(function() {
  if (window.__cdInsuranceInfoBound) return;
  window.__cdInsuranceInfoBound = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.cd-insurance [data-insurance-info-toggle]');
    if (!button) return;

    var container = button.closest('.cd-insurance');
    if (!container) return;

    var panelId = button.getAttribute('aria-controls');
    var panel = panelId ? container.querySelector('#' + CSS.escape(panelId)) : container.querySelector('[data-insurance-info-panel]');
    if (!panel) return;

    var isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

    if (isExpanded) {
      panel.setAttribute('hidden', 'hidden');
    } else {
      panel.removeAttribute('hidden');
    }
  });
})();






    const intervalInsurance = setInterval(() => {
    const form = document.querySelector('product-form.main-product-form form[action*="/cart/add"]');

    if (form) {
               
        form.addEventListener('submit', async () => {
          await addToCartInsurance()
            

        });

      clearInterval(intervalInsurance);
    }
  }, 850);




async function addToCartInsurance() {

  
  try {

      const container = document.querySelector('.cd-insurance');
  const toggle = container?.querySelector('[data-insurance-toggle]');
  const insuranceVariantId = Number(container?.dataset.variantId);
  
  if (toggle?.checked && insuranceVariantId && !isNaN(insuranceVariantId)) {
    return
  }
  
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: insuranceVariantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    // Update cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
    }

    // Update cart icon bubble (count badge)
    const cartIconBubbleHTML = data.sections?.['cart-icon-bubble'];
    if (cartIconBubbleHTML) {
      document.querySelectorAll('[id^="cart-icon-bubble"]').forEach(el => {
        el.innerHTML = new DOMParser()
          .parseFromString(cartIconBubbleHTML, 'text/html')
          .querySelector('[id^="cart-icon-bubble"]')?.innerHTML ?? '';
      });
    }

    return data;

  } catch (error) {
    console.error('Add to cart error:', error);
    throw error; // re-throw so the caller can show UI feedback
  }
}